import HeroSection from "../components/HeroSection";
import FutureDataSection from "../components/FutureDataSection";
import OurServiceSection from "../components/OurServiceSection";
import LargestAiSection from "../components/LargestAiSection";
import OurPartnerSection from "../components/OurPartnerSection";
import PopupSection from "../components/PopupSection";
import useSWR from "swr";
import { useState } from "react";
import { useInView } from "react-intersection-observer";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

function Home() {
  const [popup, setPopup] = useState(false);

  const OpenPopup = (x) => {
    setPopup(x);
  };

  // Enhanced fetcher with security headers
  const secureFetcher = (url) =>
    fetch(url, {
      headers: {
        Accept: "application/json",
        Origin: window.location.origin,
      },
      credentials: "omit",
    }).then((res) => res.json());

  const {
    data: homeData,
    error,
    isLoading,
  } = useSWR("https://47.activ8.digital/wp-json/wp/v2/pages/8", secureFetcher);
  const {
    data: partnerData,
    error: partnerError,
    isLoading: partnertLoading,
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/ourpartnerslider?per_page=100&_embed",
    secureFetcher,
  );
  const {
    data: aboutFutureData,
    error: aboutFutureError,
    isLoading: aboutFutureLoading,
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/aboutfutureslider?per_page=17&v=2",
    secureFetcher,
  );
  const {
    data: servicessliderData,
    error: servicessliderError,
    isLoading: servicessliderLoading,
  } = useSWR(
    "https://47.activ8.digital/wp-json/wp/v2/servicesslider?per_page=100&orderby=date&order=asc",
    secureFetcher,
  );

  // Section refs and inView hooks
  const [heroRef, heroInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const [futureRef, futureInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const [serviceRef, serviceInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const [largestRef, largestInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });
  const [partnerRef, partnerInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <>
      {homeData && (
        <Helmet>
          <title>{homeData.yoast_head_json?.title}</title>
          <meta
            property="og:title"
            content={homeData.yoast_head_json?.og_title}
          />
          <meta
            property="og:description"
            content={homeData.yoast_head_json?.og_description}
          />
        </Helmet>
      )}
      <motion.div
        ref={heroRef}
        initial={{ opacity: 0, y: 40 }}
        animate={heroInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        <HeroSection
          data={homeData?.acf?.hero_section}
          popup={(x) => OpenPopup(x)}
        />
      </motion.div>
      <motion.div
        ref={futureRef}
        initial={{ opacity: 0, y: 40 }}
        animate={futureInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        <FutureDataSection data={aboutFutureData} />
      </motion.div>
      <motion.div
        ref={serviceRef}
        initial={{ opacity: 0, y: 40 }}
        animate={serviceInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        <OurServiceSection
          data={homeData?.acf?.our_services_section}
          sliderData={servicessliderData}
          popup={(x) => OpenPopup(x)}
        />
      </motion.div>
      <motion.div
        ref={largestRef}
        initial={{ opacity: 0, y: 40 }}
        animate={largestInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        <LargestAiSection data={homeData?.acf?.about_largest_ai_section} />
      </motion.div>
      <motion.div
        ref={partnerRef}
        initial={{ opacity: 0, y: 40 }}
        animate={partnerInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
      >
        <OurPartnerSection
          data={partnerData}
          partnerHead={homeData?.acf?.our_partners_section}
        />
      </motion.div>
      {popup && <PopupSection popup={(x) => OpenPopup(x)} />}
    </>
  );
}
export default Home;
